import React from 'react';
import { Link } from 'react-router-dom';
import { Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

function LoginFooter() {
  return (
    <div className="pt-4 text-center border-t border-border">
      <Text size="sm" variant="muted" className="text-muted-foreground">
        Don't have an account?{' '}
        <Link 
          to="/signin_user" 
          className={cn(
            "text-primary hover:text-primary/90 font-bold",
            "transition-colors underline-offset-4 hover:underline",
            "text-base"
          )}
        >
          Sign up for free
        </Link>
      </Text>
    </div>
  );
}

export default LoginFooter;